import axios from 'axios';
import { site_url } from "./config.js";

// Create axios instance with JWT token in headers
const api = axios.create({
  baseURL: site_url,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add interceptor to include JWT token in all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt_token') || localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const blocked = error.response
      && error.response.status === 403
      && ['shop_inactive', 'staff_inactive'].includes(error.response.data?.code);
    if ((error.response && error.response.status === 401) || blocked) {
      const requestAuth = error.config?.headers?.Authorization || '';
      const currentToken = localStorage.getItem('jwt_token') || localStorage.getItem('access_token');
      const onLoginPage = window.location.pathname === '/login' || window.location.pathname === '/';

      // A newer login token was stored after this request started — do not wipe it.
      if (currentToken && requestAuth && requestAuth !== `Bearer ${currentToken}`) {
        return Promise.reject(error);
      }

      localStorage.removeItem('access_token');
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('role');
      localStorage.removeItem('staff_id');
      if (blocked && !onLoginPage && !sessionStorage.getItem('shop_block_notice')) {
        sessionStorage.setItem('shop_block_notice', '1');
        window.alert(error.response.data?.message || 'This shop is inactive. Contact admin.');
      }
      if (!onLoginPage) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
